.feedback__wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 52px;
  height: 52px;
  position: relative;
  margin: 0px 1.5rem;
}

.feedback__face {
  width: 46px;
  height: 46px;
  transition: width 0.2s;
  z-index: 10;
  flex-shrink: 0;
}

.feedback__face:hover {
  width: 52px;
  height: 52px;
}

.feedback__face_picked {
  width: 52px;
  height: 52px;
}

.feedback__sad {
  display: initial;
  position: relative;
  bottom: 20px;
}

.feedback__sadhover {
  display: none;
}

.feedback__sadhover_eyebrows {
  display: none;
}

.feedback__sadhover_eyebrowleft {
  display: none;
}

.feedback__sadhover_eyebrowright {
  display: none;
}

.feedback__face:hover ~ .feedback__sad {
  display: none;
}

.feedback__face:hover ~ .feedback__sadhover {
  display: initial;
  position: absolute;
  bottom: 15px;
  flex-shrink: 0;
}

.feedback__face:hover ~ .feedback__sadhover_eyebrowleft {
  display: initial;
  position: absolute;
  bottom: 36px;
  left: 11px;
  flex-shrink: 0;
}

.feedback__face:hover ~ .feedback__sadhover_eyebrowright {
  display: initial;
  position: absolute;
  bottom: 36px;
  right: 11px;
  flex-shrink: 0;
}

.feedback__sad_picked {
  display: none;
}

.feedback__sadhover_picked {
  display: initial;
  position: absolute;
  bottom: 15px;
  flex-shrink: 0;
}

.feedback__sadhover_eyebrowleft_picked {
  display: initial;
  position: absolute;
  bottom: 36px;
  left: 11px;
  flex-shrink: 0;
}

.feedback__sadhover_eyebrowright_picked {
  display: initial;
  position: absolute;
  bottom: 36px;
  right: 11px;
  flex-shrink: 0;
}

.feedback__indifferent {
  position: relative;
  bottom: 18px;
  left: 0px;
  border: 2px #495057 solid;
  border-radius: 4px;
  width: 22px;
  transition: width 0.25s;
  transition: left 0.25s;
}

.feedback__face:hover ~ .feedback__indifferent {
  width: 15px;
  bottom: 20px;
  left: -3px;
  transform: skewY(-8deg);
}

.feedback__indifferent_picked {
  width: 15px;
  bottom: 20px;
  left: -3px;
  transform: skewY(-8deg);
  border-color: #f96400;
}

.feedback__face:hover ~ .feedback__happy {
  display: none;
}

.feedback__happy_picked {
  display: none;
}

.feedback__happy {
  display: initial;
  position: relative;
  bottom: 18px;
  transform: rotate(180deg);
}

.feedback__happyhover {
  display: none;
}

.feedback__face:hover ~ .feedback__happyhover {
  display: initial;
  position: relative;
  bottom: 22px;
  height: 0px;
  border: 4.5px #495057 solid;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-left-radius: 70px;
  border-bottom-right-radius: 70px;
  width: 20px;
  flex-shrink: 0;
}

.feedback__happyhover_picked {
  display: initial;
  position: relative;
  bottom: 22px;
  height: 0px;
  border: 4.5px #f96400 solid !important;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-bottom-left-radius: 70px;
  border-bottom-right-radius: 70px;
  width: 20px;
  flex-shrink: 0;
}
